
const linkRewriter = (link) => {

  if (typeof link === 'string' || link instanceof String) {
    if (link.startsWith(".")) {
      return link.substr(1, link.length);
    }
  }

  return link;
};

export default linkRewriter;


// WEBPACK FOOTER //
// ./src/shared/linkRewriter.js